import { PrismicPageParser } from "../../shared/utils/prismicPageParser"
import cx from "classnames"
import styles from "./BCorpContainer.module.scss"

const BCorpContainer = () => {
  const data = JSON.parse(window.prismic_data)
  const pageId = window.pageId

  return (
    <section id="mm-bcorp" className={cx(styles.bCorp, "pageContainer")} aria-label="B Corp">
      <PrismicPageParser pageData={data} pageId={pageId} />
    </section>
  )
}

export default BCorpContainer
